import { render, staticRenderFns } from "./PublicFileUploader.vue?vue&type=template&id=7c072810&scoped=true&"
import script from "./PublicFileUploader.vue?vue&type=script&lang=js&"
export * from "./PublicFileUploader.vue?vue&type=script&lang=js&"
import style0 from "./PublicFileUploader.vue?vue&type=style&index=0&id=7c072810&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c072810",
  null
  
)

export default component.exports